
import React from 'react';

const EmployeeProfile = ({ userData }) => {
  return (
    <div>
      {/* Profile Section */}
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-4">
            <div className="card mb-4">
              <div className="card-body text-center">
                <img
                  src={userData.pic ? userData.pic : 'https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3.webp'}
                  alt="avatar"
                  className="rounded-circle img-fluid"
                  style={{ width: '150px' }}
                />
                <h5 className="my-3">{userData.name}</h5>
                <p className="text-muted mb-1">{userData.role}</p>
                <p className="text-muted mb-4">{userData.location}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="card mb-4">
              <div className="card-body">
                {/* Profile Information */}
                <div className="row">
                  <div className="col-sm-3"><p className="mb-0">Name</p></div>
                  <div className="col-sm-9"><p className="text-muted mb-0">{userData.name}</p></div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-sm-3"><p className="mb-0">Email</p></div>
                  <div className="col-sm-9"><p className="text-muted mb-0">{userData.email}</p></div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-sm-3"><p className="mb-0">Phone</p></div>
                  <div className="col-sm-9"><p className="text-muted mb-0">{userData.phone}</p></div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeProfile;
